import { render } from "./ReviewsContentRank1.vue?vue&type=template&id=40edb3f8&scoped=true"
const script = {}

import "./ReviewsContentRank1.vue?vue&type=style&index=0&id=40edb3f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40edb3f8"]])

export default __exports__